<template>
  <div class="file-upload is-flex-100" :class="file.status">
    <div class="columns p-1">
      <div class="column">
        <div class="is-cover is-preview is-clickable has-text-centered" :style="`background-image:url(https://mr.xtramuros.com/php/${file.path})`" :class="{ 'is-video': file.mime.indexOf('video') > -1 }">
         <video v-show="file.mime.indexOf('video') > -1" :src="`https://mr.xtramuros.com/php/${file.path}`" :type="file.mime" controls/>
        </div>
      </div>
    </div>
    <div class="columns is-flex-self-end p-1 is-mobile">
      <div class="column">
        <span class="is-size-7">{{ 'uploaded' | term }} {{ file.created | dateFormat }}</span>
      </div>
      <div class="column is-actions is-narrow">
        <div class="columns is-flex-self-end p-2 is-mobile">
          <div class="column">
            <span v-show="!this.removing" @click="askRemove" class="icon is-medium is-clickable">
              <svg-icon icon="trash"/>
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SvgIcon from '@/components/SvgIcon'
export default {
  name: 'FilePicker',
  components: {
    SvgIcon
  },
  props: {
    file: {
      type: Object,
      default: () => {}
    }
  },
  data () {
    return {
      removing: false,
      apiBaseUrl: process.env.VUE_APP_API_URL
    }
  },
  methods: {
    askRemove () {
      this.$emit('ask-remove', this.file)
      /* if (confirm(`Are you sure you want to remove this file?`)) {
        this.removing = true
        axios.post('/remove', this.file).then(res => {
          this.$emit('file-removed', this.file)
        })
      } */
    }
  }
}
</script>
